import { Button } from '@plaidev/sour-react';
import type { ReactElement } from 'react';
import type { CsvAnalysis } from 'troppus-common/shared';

import { type ColumnEditorContextValue, ColumnEditorProvider } from '../context/ColumnEditorContext';
import { ConfigureBasicSection } from './ConfigureBasicSection';
import { ConfigureColumnMappingSection } from './ConfigureColumnMappingSection';
import { ConfigureContractUkSection } from './ConfigureContractUkSection';
import { ConfigureCsvAnalysisSummarySection } from './ConfigureCsvAnalysisSummarySection';
import { ConfigureCustomerUkSection } from './ConfigureCustomerUkSection';

type ConfigureStepProps = {
  editor: ColumnEditorContextValue;
  analysis: CsvAnalysis;
  isSystemAdmin: boolean;
  selectedSourceSystemName: string;
  createMutationIsPending: boolean;
  isValid: boolean;
  navigateToList: () => void;
};

export function ConfigureStep({
  editor,
  analysis,
  isSystemAdmin,
  selectedSourceSystemName,
  createMutationIsPending,
  isValid,
  navigateToList,
}: ConfigureStepProps): ReactElement | null {
  if (editor.counts.all === 0) return null;

  return (
    <ColumnEditorProvider value={editor}>
      <ConfigureBasicSection selectedSourceSystemName={selectedSourceSystemName} />

      {!isSystemAdmin ? <ConfigureCsvAnalysisSummarySection analysis={analysis} /> : null}

      <ConfigureColumnMappingSection />

      <ConfigureContractUkSection />

      <ConfigureCustomerUkSection />

      <div className="flex flex-wrap gap-3">
        <Button type="submit" variant="primary" loading={createMutationIsPending} disabled={!isValid}>
          保存する
        </Button>
        <Button type="button" variant="basic" disabled={createMutationIsPending} onClick={navigateToList}>
          キャンセル
        </Button>
      </div>
    </ColumnEditorProvider>
  );
}
